import { FC, SVGProps } from 'react';

export const MsTeamsLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="4 4 36 38" aria-hidden="true" focusable="false" {...props}>
		<path fill="url(#ms-teams-a)" d="M22 20h12a6 6 0 0 1 6 6v10a6 6 0 0 1-12 0V26a6 6 0 0 0-6-6Z" />
		<path fill="url(#ms-teams-b)" d="M8 24a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v12a6 6 0 0 0 6 6H18c-5.523 0-10-4.477-10-10v-8Z" />
		<path fill="url(#ms-teams-c)" fillOpacity=".7" d="M8 24a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v12a6 6 0 0 0 6 6H18c-5.523 0-10-4.477-10-10v-8Z" />
		<path fill="url(#ms-teams-d)" fillOpacity=".7" d="M8 24a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v12a6 6 0 0 0 6 6H18c-5.523 0-10-4.477-10-10v-8Z" />
		<path fill="url(#ms-teams-e)" d="M33 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" />
		<path fill="url(#ms-teams-f)" fillOpacity=".46" d="M33 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" />
		<path fill="url(#ms-teams-g)" fillOpacity=".4" d="M33 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" />
		<path fill="url(#ms-teams-h)" d="M18 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" />
		<path fill="url(#ms-teams-i)" fillOpacity=".6" d="M18 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" />
		<path fill="url(#ms-teams-j)" fillOpacity=".5" d="M18 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" />
		<rect width="16" height="16" x="4" y="23" fill="url(#ms-teams-k)" rx="3.25" />
		<rect width="16" height="16" x="4" y="23" fill="url(#ms-teams-l)" fillOpacity=".7" rx="3.25" />
		<path fill="#fff" d="M15.48 28.105h-2.448v7.466h-2.065v-7.466H8.52V26.43h6.96v1.676Z" />
		<defs>
			<radialGradient id="ms-teams-a" cx="0" cy="0" r="1" gradientTransform="matrix(13.4784 0 0 33.2694 39.797 22.174)" gradientUnits="userSpaceOnUse">
				<stop stopColor="#A98AFF" />
				<stop offset=".14" stopColor="#8C75FF" />
				<stop offset=".565" stopColor="#5F50E2" />
				<stop offset=".9" stopColor="#3C2CB8" />
			</radialGradient>
			<radialGradient
				id="ms-teams-b"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="matrix(12.1875 30.39997 -30.74442 12.3256 8.812 16.4)"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#85C2FF" />
				<stop offset=".69" stopColor="#7588FF" />
				<stop offset="1" stopColor="#6459FE" />
			</radialGradient>
			<radialGradient
				id="ms-teams-d"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="rotate(113.326 8.093 17.645) scale(19.2186 15.4273)"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#BD96FF" />
				<stop offset=".687" stopColor="#BD96FF" stopOpacity="0" />
			</radialGradient>
			<radialGradient id="ms-teams-e" cx="0" cy="0" r="1" gradientTransform="matrix(0 -10 12.6216 0 33 11.571)" gradientUnits="userSpaceOnUse">
				<stop offset=".268" stopColor="#6868F7" />
				<stop offset="1" stopColor="#3923B1" />
			</radialGradient>
			<radialGradient
				id="ms-teams-f"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="matrix(5.47024 4.59847 -6.65117 7.91208 28.867 10.544)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".271" stopColor="#A1D3FF" />
				<stop offset=".813" stopColor="#A1D3FF" stopOpacity="0" />
			</radialGradient>
			<radialGradient
				id="ms-teams-g"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="rotate(-41.658 32.118 -43.42) scale(8.51275 20.8824)"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#E3ACFD" />
				<stop offset=".816" stopColor="#9FA2FF" stopOpacity="0" />
			</radialGradient>
			<radialGradient id="ms-teams-h" cx="0" cy="0" r="1" gradientTransform="matrix(0 -12 15.146 0 18 8.286)" gradientUnits="userSpaceOnUse">
				<stop offset=".268" stopColor="#8282FF" />
				<stop offset="1" stopColor="#3923B1" />
			</radialGradient>
			<radialGradient
				id="ms-teams-i"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="rotate(40.052 -3.155 21.416) scale(8.57554 12.4035)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset=".271" stopColor="#A1D3FF" />
				<stop offset=".813" stopColor="#A1D3FF" stopOpacity="0" />
			</radialGradient>
			<radialGradient
				id="ms-teams-j"
				cx="0"
				cy="0"
				r="1"
				gradientTransform="rotate(-41.658 20.382 -26.516) scale(10.2153 25.0589)"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#E3ACFD" />
				<stop offset=".816" stopColor="#9FA2FF" stopOpacity="0" />
			</radialGradient>
			<radialGradient id="ms-teams-k" cx="0" cy="0" r="1" gradientTransform="rotate(45 -25.763 16.328) scale(22.6274)" gradientUnits="userSpaceOnUse">
				<stop offset=".047" stopColor="#688EFF" />
				<stop offset=".947" stopColor="#230F94" />
			</radialGradient>
			<radialGradient id="ms-teams-l" cx="0" cy="0" r="1" gradientTransform="matrix(0 11.2 -13.0702 0 12 32.6)" gradientUnits="userSpaceOnUse">
				<stop offset=".571" stopColor="#6965F6" stopOpacity="0" />
				<stop offset="1" stopColor="#8F8FFF" />
			</radialGradient>
			<linearGradient id="ms-teams-c" x1="20.594" x2="20.594" y1="18" y2="42" gradientUnits="userSpaceOnUse">
				<stop offset=".801" stopColor="#6864F6" stopOpacity="0" />
				<stop offset="1" stopColor="#5149DE" />
			</linearGradient>
		</defs>
	</svg>
);
